export const environment = {
    production:false,
    baseUrl:document.location.protocol + "//" + document.location.hostname + ":" + document.location.port,
    // baseUrl:'https://preproduction.huloop.ai',
    app_url: 'https://dev-v5.huloop.ai:444/websocket-demo/ws',
    url: '/HuLoopRest/huloop',
    okta_sso: document.location.protocol + "//" + document.location.hostname + '/api/okta/web',
    azure_sso:  document.location.protocol + "//" + document.location.hostname + '/saml/login?disco=true',
    chatBotEnable : true,
    okta:false,
    DISPLAY_GENAI : true,
    customerName: ['verizon'],
    disableRightClick: true,
    encryptedEnable:true,
   workflowUrl:document.location.protocol + "//" + document.location.hostname,
   workflowUIUrl:document.location.protocol + "//" + document.location.hostname +'/workflow'
  //  workflowUrl: 'https://dev-v5.huloop.ai:8443',
  //  workflowUIUrl:'http://localhost:5200'
// HuLoopSubscriptionRest/HuLoopsubscription and /HuLoopRest/huloopld
}

  